import ProfilePatients from './profile-patients.vue'
export default ProfilePatients